<template>
    <div class="home" v-cloak>
        <div class="hero-banner">
            <img :src="require('../assets/banner.jpg')" alt="" rel="preload" class="desktop">
            <img :src="require('../assets/banner_m.jpg')" alt="" rel="preload" class="mobile">
        </div>
        <div class="albums">
            <div class="container">
                <h3 class="text-center mb-3 mt-5">音檔下載</h3>
                <p class="text-center mb-5">( 下方有解壓縮說明影片 )</p>   
                <div class="row">
                    <div class="col-6 col-md-3 mb-5 text-left"
                    v-for="album in albums" :key="album.id">
                        <div class="cover_image">
                            <img :src="require('../assets/album_'+album.id+'.jpg')" alt="" rel="preload" class="desktop">
                            <img :src="require('../assets/album_'+album.id+'_m.jpg')" alt="" rel="preload" class="mobile">
                        </div>
                        <h6 class="title">{{album.name}}</h6>
                        <p>共 {{album.amountOfSongs}} 首歌</p>
                        <a :href="album.downloadLink" download>
                            <button>整冊下載</button>
                        </a>
                    </div>
                </div>
                <p class="url mt-5 pb-5">下載網址 http://music.florapiano.com</p>
            </div>
        </div>
        <div class="demo-videos">
            <div class="container">
                <h3 class="text-center mb-5 mt-5">如何解壓縮</h3>
                <div class="row">
                    <div class="col-12 col-md-4 mb-5 text-left video-item"
                    v-for="demoVideo in demoVideos" :key="demoVideo.id">
                        <!-- <a :href="'https://www.youtube.com/watch?v='+demoVideo.videoId">
                            <div class="cover_image">
                                <img :src="demoVideo.coverImg" alt="" rel="preload">
                            </div>
                        </a> -->
                        <VuePureLightbox
                            :thumbnail="demoVideo.coverImg"
                            :images="['/video/'+demoVideo.videoId]"
                        />
                        <h6 class="title">{{demoVideo.title}}</h6>
                        
                    </div>
                </div>
                <hr>
                <div class="app-download mt-5 mb-3">下載行動裝置解壓縮軟體 <span class="mobile-br"><a href="https://apps.apple.com/tw/app/unzip-zip-file-opener/id1281374098" target="_blank">(for iOS)</a> / <a href="https://play.google.com/store/apps/details?id=com.rarlab.rar&hl=zh_TW" target="_blank">(for Android)</a></span></div>
                <div class="app-download mb-5">下載電腦版解壓縮軟體 <span class="mobile-br"><a href="https://apps.apple.com/tw/app/rar-extractor-and-expander/id1071663619?mt=12" target="_blank">(for Mac)</a> / <a href="https://tw.bandisoft.com/bandizip/" target="_blank">(for PC)</a></span></div>

            </div>
        </div>
        
        
    </div>
</template>

<script>
import albums from '@/data/albums.js';
import demoVideos from '@/data/demoVideos.js';
import VuePureLightbox from 'vue-pure-lightbox';
import styles from 'vue-pure-lightbox/dist/VuePureLightbox.css';

export default {
    name: 'home',
    components: {
        VuePureLightbox,
    },
    data () {
        return {
            albums: albums,
            demoVideos: demoVideos
        }
    },
    mounted () {
        $(document).ready(function () {
            $('.owl-carousel.slider-1').owlCarousel({
                loop: false,
                items: 1.5,
                center: true,
                margin: 30,
                nav: false,
                dots: false,
            })
            $('.owl-carousel.slider-2').owlCarousel({
                loop: false,
                items: 1.5,
                center: true,
                margin: 30,
                nav: false,
                dots: false,
            })
            // console.log('carousel init.')
        })
    },
    watch: {

    }
}

</script>

<style lang="sass">
    body
        overflow-x: hidden
        letter-spacing: 1px
    .desktop
        @media screen and (max-width : 991px)
            display: none
    .mobile
        display: none
        @media screen and (max-width : 991px)
            display: block
    .mobile-br
        @media screen and (max-width : 767px)
            display: block
    .hero-banner
        img
            width: 100%
    .albums,.demo-videos
        padding-top: 50px
        background-color: #f8fafb
        .cover_image
            transition: 0.3s
            border-radius: 6px
            overflow: hidden
            img
                width: 100%
        .title
            font-size: 16px
            color: rgba(0,0,0,0.75)
            letter-spacing: 0.5px
            margin-top: 16px
            font-weight: 700
            @media screen and (max-width : 767px)
                margin-top: 12px
            &+p
                color: rgba(0,0,0,0.5)
                font-size: 14px
                letter-spacing: 1px
                font-weight: 500
                letter-spacing: .1em
                margin-bottom: .5rem
                @media screen and (max-width : 767px)
                    margin-bottom: 6px
        button
            background: none
            border: 2px solid #31a7be
            border-radius: 2px
            color: #31a7be
            font-size: 14px
            padding: 10px 20px
            letter-spacing: .1em
            font-weight: 700
            &:focus
                outline: 0
    .albums
        .title
            @media screen and (max-width : 991px)
                text-overflow: ellipsis
                overflow: hidden
                height: 1em
                white-space: nowrap
        p.url
            color: rgba(0,0,0,0.45)
    .demo-videos
        padding-top: 50px
        background-color: #fff
        .title
            font-size: 16px
            color: rgba(0,0,0,0.75)
            letter-spacing: 0.5px
            margin-top: 16px
            font-weight: 700
            @media screen and (max-width : 767px)
                margin-top: 12px
            &+p
                color: rgba(0,0,0,0.5)
                font-size: 14px
                letter-spacing: 1px
                font-weight: 300
                letter-spacing: .1em
                margin-bottom: .5rem
                @media screen and (max-width : 767px)
                    margin-bottom: 6px
        .lightbox__thumbnail
            position: relative
            &:after
                content: ""
                display: block
                width: 50px
                height: 50px
                background-image: url('../assets/play.png')
                background-repeat: no-repeat
                background-size: contain
                position: absolute
                top: 0
                bottom: 0
                right: 0
                left: 0
                margin: auto
        hr
            background: rgba(0,0,0,0.20)
        .app-download
            line-height: 2em
            font-size: 14px
            @media screen and (min-width : 768px)
                text-align: left
            a
                color: rgba(49, 167, 190, 0.9)
                font-weight: 700
            &+.app-download
                margin-bottom: 100px
        video
            max-height: 80vh
            &:focus
                outline: 0
        .lightbox
            z-index: 11
        .video-item
            @media screen and (min-width : 1025px)
                &:hover
                    .lightbox__thumbnail:after
                        filter: brightness(0.9)


    
</style>
